import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;

  constructor(Auth, $state, WebAccessService, SettingsService) {
    'ngInject';
    this.$state = $state;
    this.Auth = Auth;
    this.WebAccessService = WebAccessService;

    this.name = "";

    SettingsService.getByName({name: 'config.platform'}, settings => {
      this.client = settings.data.clientName;
    })

    SettingsService.getByName({name: 'client'}, settings => {
      let imageUrl = settings.data.frontpage ? '/api/storage/' + settings.data.frontpage : '/assets/images/frontpage.jpeg';
      jQuery(".frontpage").css('background-image', 'url(' + imageUrl + ')');
    })
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password
      })
        .then(user => {

          console.log(user);

          if (user.role.includes('admin')) {
            // Logged in, redirect to home
            this.$state.go('admin-home');
          } else {
            if (user.provider === 'local-webaccess') {
              this.WebAccessService.updateLastLoggedIn({webaccessId: user.webaccessId}, {date: new Date()});
            }
            // Logged in, redirect to home
            this.$state.go('home');
          }

        })
        .catch(err => {
          this.errors.login = Array.isArray(err) ? err[0].message : err.message;
        });
    }
  }
}

export default angular.module('conduu.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js